<app-generic-form title="Modifica Gioco" [wide]="true">
  <form [formGroup]="editGameForm" (ngSubmit)="onSubmit()" id="editGameForm" form-content>
    <div>
      <label for="gameName" class="form-label">Nome del Gioco</label>
      <input type="text" formControlName="gameName" id="gameName" class="form-control" required>
    </div>
    <div>
      <label for="gameDescription" class="form-label">Descrizione</label>
      <textarea formControlName="gameDescription" id="gameDescription" class="form-control" required></textarea>
    </div>
    <div>
      <label for="gameType" class="form-label">Tipo di Gioco</label>
      <select formControlName="gameType" id="gameType" class="form-select" required>
        <option value="RPG">RPG</option>
        <option value="TTG">TTG</option>
        <option value="MIXED">MIXED</option>
        <option value="GENERIC">GENERIC</option>
      </select>
    </div>
    <div>
      <label for="minPlayers" class="form-label">Giocatori minimi:</label>
      <input type="number" formControlName="minPlayers" id="minPlayers" min="1" class="form-control">
    </div>
    <div>
      <label for="maxPlayers" class="form-label">Giocatori Massimi</label>
      <input type="number" formControlName="maxPlayers" id="maxPlayers" min="1" class="form-control">
    </div>

    @if (canRelink()) {
      <div class="card my-3 border-warning" data-cy="game-relink-section">
        <div class="card-header bg-warning text-dark fw-bold d-flex align-items-center justify-content-between">
          <span><i class="bi bi-link-45deg me-2"></i>Ricongiungi con BoardGameGeek / RPGGeek</span>
          <span class="badge bg-dark text-white">Solo Amministratori</span>
        </div>
        <div class="card-body">
          <p class="card-text small text-muted">
            Questo gioco è stato creato manualmente e non possiede un ID BGG/RPG. Cerca il gioco su BGG o RPGGeek per riconfigurare e aggiornare i dati mantenendo l'ID esistente e i vincoli di integrità referenziali.
          </p>

          <div class="row g-2 align-items-center mb-3">
            <div class="col-auto">
              <div class="btn-group" role="group">
                <button type="button" class="btn btn-sm"
                  [class.btn-primary]="relinkProvider() === 'bgg'"
                  [class.btn-outline-primary]="relinkProvider() !== 'bgg'"
                  (click)="relinkProvider.set('bgg')">
                  BGG
                </button>
                <button type="button" class="btn btn-sm"
                  [class.btn-primary]="relinkProvider() === 'rpg'"
                  [class.btn-outline-primary]="relinkProvider() !== 'rpg'"
                  (click)="relinkProvider.set('rpg')">
                  RPGGeek
                </button>
              </div>
            </div>

            <div class="col">
              <input type="text" class="form-control form-control-sm"
                [placeholder]="relinkProvider() === 'rpg' ? 'Cerca su RPGGeek (es. D&D o ID)' : 'Cerca su BGG (es. Catan o ID)'"
                [value]="relinkQuery()" (input)="relinkQuery.set($any($event.target).value)" (keyup.enter)="searchRelink()" data-cy="relink-search-input">
            </div>

            <div class="col-auto">
              <button type="button" class="btn btn-warning btn-sm" (click)="searchRelink()" [disabled]="isRelinkSearching()" data-cy="relink-search-button">
                @if (isRelinkSearching()) {
                  <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                } @else {
                  <i class="bi bi-search me-1"></i>
                }
                Cerca
              </button>
            </div>
          </div>

          @if (relinkSearchResults().length > 0) {
            <div class="list-group" data-cy="relink-results-list">
              @for (result of relinkSearchResults(); track result.id) {
                <div class="list-group-item d-flex justify-content-between align-items-center">
                  <div>
                    <strong>{{ result.name.value }}</strong>
                    @if (result.yearPublished?.value) {
                      <span class="text-muted small ms-2">({{ result.yearPublished?.value }})</span>
                    }
                    <span class="badge bg-secondary ms-2">ID: {{ result.id }}</span>
                  </div>
                  <button type="button" class="btn btn-sm btn-success" (click)="applyRelink(result)" [disabled]="isRelinking()" data-cy="apply-relink-btn">
                    <i class="bi bi-link-45deg me-1"></i>Ricongiungi e Aggiorna
                  </button>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }

    <hr class="my-3">
    <h6 class="text-muted mb-2">Dati BGG</h6>
    <div>
      <label for="yearPublished" class="form-label">Anno pubblicazione</label>
      <input type="number" formControlName="yearPublished" id="yearPublished" class="form-control">
    </div>
    <div>
      <label for="playingTime" class="form-label">Durata (minuti)</label>
      <input type="number" formControlName="playingTime" id="playingTime" class="form-control">
    </div>
    <div>
      <label for="minAge" class="form-label">Età minima</label>
      <input type="number" formControlName="minAge" id="minAge" class="form-control">
    </div>
    <div>
      <label for="imageUrl" class="form-label">URL immagine</label>
      <input type="text" formControlName="imageUrl" id="imageUrl" class="form-control">
    </div>
    <div>
      <label for="thumbnailUrl" class="form-label">URL thumbnail</label>
      <input type="text" formControlName="thumbnailUrl" id="thumbnailUrl" class="form-control">
    </div>
    <div>
      <label for="averageRating" class="form-label">Rating medio BGG</label>
      <input type="number" formControlName="averageRating" id="averageRating" class="form-control" step="0.1">
    </div>
    <div>
      <label for="bggRank" class="form-label">Rank BGG</label>
      <input type="number" formControlName="bggRank" id="bggRank" class="form-control">
    </div>
  </form>
  <div class="d-flex justify-content-between" form-actions>
    <button type="button" class="btn btn-secondary" (click)="goBack()">
      <i class="bi bi-x-lg me-1" aria-hidden="true"></i>Annulla
    </button>
    <button type="submit" form="editGameForm" class="btn btn-primary" [disabled]="editGameForm.invalid">
      <i class="bi bi-check-lg me-1" aria-hidden="true"></i>Salva Modifiche
    </button>
  </div>
</app-generic-form>
